import { ref } from 'vue';
import ReportRepository from '@/repositories/report/ReportRepository.ts';
import {
    CarPlacementSaleReport,
    CarPlacementSaleReportsPaginator,
    CarPlacementSaleReportsRequestFilter,
    ReportAuction,
    ReportAuctionsPaginator,
    ReportAuctionsRequestFilter,
    ReportBid,
} from '@/types/report.type.ts';
import { PaginationMeta } from '@/types/pagination-meta.ts';
import useLoading from '@/utils/useLoading.ts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useReportRepository() {
    const arBidReportAuctions = ref<ReportAuction[]>([]);
    const bidReportAuctionsPaginationMeta = ref<PaginationMeta | null>(null);
    const { isLoading: isBidReportAuctionsLoading, setLoading: setBidReportAuctionsLoading } = useLoading();

    const arCarPlacementSaleReports = ref<CarPlacementSaleReport[]>([]);
    const carPlacementSaleReportsPaginationMeta = ref<PaginationMeta | null>(null);
    const { isLoading: isCarPlacementSaleReportsLoading, setLoading: setCarPlacementSaleReportsLoading } = useLoading();

    const reportRepository = new ReportRepository();

    function getBidReportAuctions(requestFilter?: ReportAuctionsRequestFilter): void {
        setBidReportAuctionsLoading(true);

        reportRepository.getBidReportAuctions(requestFilter)
            .then((reportAuctionsPaginator: ReportAuctionsPaginator) => {
                arBidReportAuctions.value = reportAuctionsPaginator.data;
                bidReportAuctionsPaginationMeta.value = reportAuctionsPaginator.meta;
                setBidReportAuctionsLoading(false);
            });
    }

    function getBidReportAuction(id: number): Promise<ReportBid[]>
    {
        return reportRepository.getBidReportAuction(id);
    }

    function getCarsPostingAndSellingReports(requestFilter?: CarPlacementSaleReportsRequestFilter): void {
        setCarPlacementSaleReportsLoading(true);

        reportRepository.getCarsPostingAndSellingReports(requestFilter)
            .then((reportsPaginator: CarPlacementSaleReportsPaginator) => {
                arCarPlacementSaleReports.value = reportsPaginator.data;
                carPlacementSaleReportsPaginationMeta.value = reportsPaginator.meta;
                setCarPlacementSaleReportsLoading(false);
            });
    }

    function regenerateCarsPostingAndSellingReport(id: number): Promise<void>
    {
        return reportRepository.regenerateCarsPostingAndSellingReport(id);
    }

    return {
        arBidReportAuctions,
        bidReportAuctionsPaginationMeta,
        isBidReportAuctionsLoading,
        arCarPlacementSaleReports,
        carPlacementSaleReportsPaginationMeta,
        isCarPlacementSaleReportsLoading,
        getBidReportAuctions: getBidReportAuctions,
        getBidReportAuction: getBidReportAuction,
        getCarsPostingAndSellingReports: getCarsPostingAndSellingReports,
        regenerateCarsPostingAndSellingReport: regenerateCarsPostingAndSellingReport,
    };
}
